import { useNavigate } from 'react-router-dom'
import './index.css'
import { Box, Grid, Typography } from '@mui/material'
import Button from 'components/Common/Button'
import { useState, useContext } from 'react'
import { DISABLED_BUTTON, PRIMARY_BUTTON } from 'themes/theme'
import { AuthStateContext } from 'context/auth'
import ZendeskLink from 'components/Common/ZendeskLink'

const sx = {
  errorMessage: {
    color: "#D14343" 
  }
}

const NameVerifyMob = () => {
  const navigate = useNavigate()
  const [firstName, setFirstName] = useState()
  const [isFirstNameValid, setisFirstNameValid] = useState(true)
  const [isLastNameValid, setisLastNameValid] = useState(true)
  const [lastName, setLastName] = useState()
  const [authState, authDispatch] = useContext(AuthStateContext)

  const handleSubmit = e => {
    e.preventDefault()
    authDispatch({ type: 'signIntoSignUpMob', payload: { email: authState.email.toLowerCase(), firstName, lastName } })
    navigate('/auth/mobile/password')
  }
  return (
    <Box
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      display="flex"
      color="#66668F"
      marginTop="46px"
      textAlign="center"
    >
      <Typography variant="h6" margin="40px 0px" color="#25245f">
        Next, fill in your name
      </Typography>
      <Box onSubmit={handleSubmit} className="mt-3" component="form">
        <Box className="my-3 authForm" paddingX="50px">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <input
                onChange={e => {
                  const htmlTagRegex = /<[^>]*>/
                  htmlTagRegex.test(e.target.value) ?  setisFirstNameValid(false) : setisFirstNameValid(true)
                  setFirstName(e.target.value)
                }}
                type="text"
                name="firstName"
                placeholder="First Name"
                style={{ padding: '13px 15px', fontSize: '16px' }}
                className={isFirstNameValid ?   "form-control" : "form-control form-control-invalid" }
                id="firstName"
              />
              {!isFirstNameValid && 
              <Typography sx={sx.errorMessage} variant="caption">{"HTML tags are not allowed in the first name"}</Typography>
              }
            </Grid>
            <Grid item xs={12} md={6}>
              <input
                onChange={e => { 
                  const htmlTagRegex = /<[^>]*>/
                  htmlTagRegex.test(e.target.value) ? setisLastNameValid(false) : setisLastNameValid(true) 
                  setLastName(e.target.value)
                }}
                type="text"
                placeholder="Last Name"
                style={{ padding: '13px 15px', marginTop: '10px', fontSize: '16px' }}
                className={isLastNameValid ?   "form-control" : "form-control form-control-invalid" }
                id="lastName"
                name="lastName"
              />
              {!isLastNameValid&& 
              <Typography sx={sx.errorMessage} variant="caption">{"HTML tags are not allowed in the last name"}</Typography>
              }
            </Grid>
          </Grid>
        </Box>
        <Box className="mt-5" display="flex" justifyContent="center" marginBottom="40px">
          <Button
            type={firstName && isFirstNameValid && lastName && isLastNameValid ? PRIMARY_BUTTON : DISABLED_BUTTON}
            style={{ width: '250px', height: '50px' }}
            submit
          >
            Continue
          </Button>
        </Box>
        <Box marginBottom="40px">
          <Typography variant="caption">
            Already have an account?
            <br />
            Please go to your desktop to sign in.
          </Typography>
        </Box>
      </Box>
      <Box margin="40px">
        <Typography variant="caption">
          By creating an account, I acknowledge I have read, understand, and agree to the Markaaz’s&nbsp;
          <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/terms-and-conditions" target="_blank">
            Terms and Conditions
          </a>
          , including the arbitration, limitation of liability, and class waiver provisions. I also confirm I have read
          and understand the Markaaz &nbsp;
          <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/privacy/" target="_blank">
            Privacy Policy
          </a>
          .
        </Typography>
      </Box>
      <ZendeskLink />
    </Box>
  )
}

export default NameVerifyMob
